'use strict';

/**
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var CollectionView = require('base/Colido.CollectionView');
var ManageCatalogsItemView = require('../partials/manage-catalogs-item');
var ManageCatalogsEmptyView = require('../partials/manage-catalogs-empty');

var ManageCatalogsListView = CollectionView.extend({
    tagName: 'ul',

    className: function() {
        return App.CollectionModule.catalogs.length ? 'list list-flex' : '';
    },

    childView: ManageCatalogsItemView,

    emptyView: ManageCatalogsEmptyView,

    collectionEvents: {
        'remove': 'updateClassName', //@todo switch to 'update' event after backbone update
    },

    updateClassName: function() {
        this.$el.removeClass().addClass(_.result(this, 'className'));
    },
});

module.exports = ManageCatalogsListView;